import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'
import { FaEdit, FaTimes } from 'react-icons/fa'

const ShiftsTable = ({
    shifts,
    onDelete,
    onEdit
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Name',
                accessorKey: 'name',
            },
            {
                header: 'Start At',
                accessorKey: 'start_at',
            },
            {
                header: 'End At',
                accessorKey: 'end_at',
            },
            {
                header: 'Created By',
                accessorKey: 'user.name'
            },
            {
                header: 'Created At',
                accessorKey: 'created_at'
            },
            {
                header: 'Updated At',
                accessorKey: 'updated_at'
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaTimes 
                            className='fa-times'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                            title='Delete'
                        />
                        <FaEdit
                            className='fa-edit'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                            title='Edit'
                        />
                    </>
                )
            }
        ]
        ,[onDelete, onEdit]
    );

    const table = useReactTable({
        data: shifts,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (shifts.length === 0){
        return <div className="text-center">No shifts found</div>
    }
  return (
    <table className='table table-striped'>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ShiftsTable